/* Eddie cart — live free-shipping progress bar
 * Polls /cart.js after any cart mutation and updates the bar without reload.
 * Hooks: Dawn PubSub (cartUpdate), MutationObserver on totals, qty-input clicks. */
(function () {
  if (window.__eddieCartBound) return;
  window.__eddieCartBound = true;

  /* ===== Reservation countdown timer ===== */
  function initReserve() {
    var el = document.querySelector('[data-eddie-reserve]');
    if (!el) return;
    var timeEl = el.querySelector('[data-eddie-reserve-time]');
    if (!timeEl) return;
    var duration = parseInt(el.dataset.duration || '600', 10) * 1000;
    var KEY = 'eddie_cart_reserve_until';
    var until = parseInt(sessionStorage.getItem(KEY) || '0', 10);
    var now = Date.now();
    if (!until || until < now - 60000) {
      until = now + duration;
      sessionStorage.setItem(KEY, String(until));
    }
    function tick() {
      var remaining = Math.max(0, until - Date.now());
      var mins = Math.floor(remaining / 60000);
      var secs = Math.floor((remaining % 60000) / 1000);
      timeEl.textContent = mins + ':' + (secs < 10 ? '0' + secs : secs);
      if (remaining <= 0) {
        el.classList.add('eddie-reserve--expired');
        el.querySelector('.eddie-reserve__text').innerHTML =
          'Reservation expired — <a href="#" onclick="sessionStorage.removeItem(\'' + KEY + '\');location.reload();return false;" style="color:#d92020;text-decoration:underline;">renew now</a>';
        clearInterval(window.__eddieReserveInterval);
      }
    }
    tick();
    window.__eddieReserveInterval = setInterval(tick, 1000);
  }
  document.addEventListener('DOMContentLoaded', initReserve);

  function fmtMoney(cents, iso) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'pl-PL', {
        style: 'currency', currency: iso || 'PLN'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
    }
  }

  function paint(cart) {
    var bars = document.querySelectorAll('[data-eddie-ship-bar]');
    if (!bars.length) return;
    bars.forEach(function (bar) {
      var threshold = parseInt(bar.dataset.threshold || '14900', 10);
      var iso = bar.dataset.currency || 'PLN';
      if (cart.currency) iso = cart.currency;
      var total = cart.total_price;
      var remaining = threshold - total;
      var pct = Math.min(100, Math.max(4, total * 100 / threshold));
      /* Free-shipping threshold bar ACTIVE ($49). Set to true to force "unlocked for everyone". */
      var forceShippingUnlocked = false;
      if (forceShippingUnlocked) { remaining = 0; pct = 100; }

      var fill = bar.querySelector('[data-eddie-fill]');
      var truck = bar.querySelector('[data-eddie-truck]');
      var text = bar.querySelector('[data-eddie-text]');
      if (fill) fill.style.width = pct + '%';
      if (truck) truck.style.left = pct + '%';
      if (text) {
        if (remaining > 0) {
          text.innerHTML = 'Brakuje ci <strong data-eddie-remaining>' + fmtMoney(remaining, iso) +
                           '</strong> do <strong>darmowej dostawy!</strong>';
        } else {
          text.innerHTML = '<span class="eddie-ship-bar__unlocked">Gratulacje! Masz darmową dostawę i wszystkie promocje.</span>';
        }
      }
    });
  }

  function refresh() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js',
          { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(paint)
      .catch(function () { /* silent */ });
  }

  // Debounce so rapid +/+ clicks only refresh once
  var t;
  function refreshDebounced() {
    clearTimeout(t);
    t = setTimeout(refresh, 350);
  }

  // 1) Dawn PubSub if available
  document.addEventListener('DOMContentLoaded', function () {
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refresh); } catch (e) {}
    }
  });

  // 2) Click-based fallback (works on every theme)
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.closest('quantity-input, [name="plus"], [name="minus"], .cart-remove-button, cart-remove-button, a[href*="/cart/change"]')) {
      refreshDebounced();
    }
  }, true);

  // 3) Quantity input direct typing
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches('input[name="updates[]"], input.quantity__input')) {
      refreshDebounced();
    }
  }, true);

  // 4) MutationObserver on totals as last-resort safety net
  function attachObserver() {
    var totals = document.querySelector('.totals__total-value');
    if (!totals) return;
    new MutationObserver(refreshDebounced).observe(totals, { childList: true, subtree: true, characterData: true });
  }
  document.addEventListener('DOMContentLoaded', attachObserver);

  // 5) Hook fetch() for cart endpoints (catches AJAX adds from add-to-cart elsewhere)
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var p = origFetch.apply(this, arguments);
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(refreshDebounced).catch(function () {});
      }
      return p;
    };
  }
})();

;(function(){try{if(!/[?&]d2cart=1\b/.test(location.search))return;try{history.replaceState(null,"",location.pathname);}catch(e){}if(sessionStorage.getItem("d2cl"))return;sessionStorage.setItem("d2cl","1");setTimeout(function(){try{sessionStorage.removeItem("d2cl")}catch(e){}},4000);var n=0,iv=setInterval(function(){var ic=document.querySelector("#cart-icon-bubble")||document.querySelector('a[href="/cart"]')||document.querySelector(".header__icon--cart");if(ic){clearInterval(iv);ic.click();}else if(++n>25){clearInterval(iv);}},150);}catch(e){}})();

/* ── d2-addlock ── одно касание = один товар. (найдено полигоном 2026-07-30)
 *
 * Три быстрых клика по «ADD TO CART» клали ВОСЕМЬ штук вместо двух. На телефоне двойное
 * касание — обычное дело: палец дёрнулся, кнопка сработала дважды. Покупатель получал счёт
 * вдвое больше, чем хотел, и это не потерянный заказ, а возврат и злой клиент.
 *
 * Замок ставится в фазе перехвата, ДО обработчиков темы, поэтому глушит и наш код, и родной
 * шопифаевский, и любое приложение. Он ПОКНОПОЧНЫЙ: повтор по той же кнопке — это дребезг,
 * а тап по другой кнопке (второй апселл) — осознанное действие, его пропускаем.
 * Отправку формы, вызванную нашим же кликом, замок не трогает — иначе он убил бы покупку.
 */
(function () {
  if (window.__d2AddLock) return;
  window.__d2AddLock = true;

  var BUY = '[name="add"], .product-form__submit, .vt-buy-btn, .vt-cta-bar__btn, .d2-rf__btn,' +
            ' .d2-upsell__add, button[type="submit"][form*="product"]';
  var HOLD = 1400;        // мс: короче — двойное касание проскочит; длиннее — мешает живым людям
  var GRACE = 400;        // мс: окно, в котором отправка формы считается следствием нашего клика
  var stamps = (typeof WeakMap === 'function') ? new WeakMap() : null;
  var lastAny = 0;

  function buyEl(t) {
    if (!t || !t.closest) return null;
    return t.closest(BUY) ||
           (t.parentElement && t.parentElement.closest ? t.parentElement.closest(BUY) : null);
  }

  function seen(el) {
    if (stamps) return stamps.get(el) || 0;
    return parseInt(el.getAttribute('data-d2last') || '0', 10);
  }

  function mark(el, t) {
    if (stamps) stamps.set(el, t);
    else el.setAttribute('data-d2last', String(t));
  }

  function onTap(e) {
    var b = buyEl(e.target);
    if (!b) return;
    var now = Date.now();
    if (now - seen(b) < HOLD) {          // та же кнопка, повтор в пределах окна = дребезг
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    mark(b, now);
    lastAny = now;
    b.setAttribute('aria-busy', 'true');
    setTimeout(function () { b.removeAttribute('aria-busy'); }, HOLD);
  }

  /* ТОЛЬКО click. На реальном телефоне тап рождает ДВА события — touchend, затем click.
     Слушая оба, замок помечал кнопку на touchend и убивал последующий click — тот самый,
     что запускает покупку. Итог: на настоящих пальцах кнопки были мертвы, а автотесты
     (жмущие программным click) — зелёные. 2026-07-30, найдено Артуром на живом трафике. */
  document.addEventListener('click', onTap, true);       // capture: раньше всех остальных

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute) return;
    if ((f.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    var now = Date.now();
    if (now - lastAny <= GRACE) return;   // это отправка от нашего же клика — пропускаем
    if (now - seen(f) < HOLD) {           // повторная отправка той же формы (Enter, скрипт)
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    mark(f, now);
    lastAny = now;
  }, true);
})();

/* ===== Cart-drawer upsell "add" — PERSISTENT delegated handler =====
 * Lives here (external, defer-loaded on every page) NOT inline in the drawer snippet,
 * because the inline version only ran when cart!=empty at page load and never re-bound
 * after renderContents() (innerHTML doesn't execute injected <script>) → upsell "add"
 * was dead for every cold-traffic / empty-cart-first-add visitor (esp. mobile).
 * A delegated document click bound once on page load survives ALL drawer re-renders. */
;(function(){
  if (window.__d2UpsellAdd) return;
  window.__d2UpsellAdd = true;
  function handle(e){
    var t = e.target;
    var b = (t && t.closest) ? t.closest('.d2-upsell__add') : null;
    if (!b && t && t.parentElement && t.parentElement.closest) b = t.parentElement.closest('.d2-upsell__add');
    if (!b) return;
    e.preventDefault();
    if (b.dataset.d2busy === '1') return;          // ignore double-tap while in flight
    var vid = b.getAttribute('data-vid');
    if (!vid) return;
    b.dataset.d2busy = '1';
    var orig = b.textContent;
    b.disabled = true; b.textContent = '✓';
    var cd = document.querySelector('cart-drawer');
    var ids = (cd && cd.getSectionsToRender) ? cd.getSectionsToRender().map(function(s){return s.id;}) : ['cart-drawer'];
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }], sections: ids, sections_url: location.pathname })
    })
    .then(function(r){ return r.json(); })
    .then(function(resp){
      if (cd && cd.renderContents) { cd.renderContents(resp); } else { location.reload(); }
    })
    .catch(function(){ b.disabled = false; b.textContent = orig; b.dataset.d2busy = '0'; });
  }
  // Bind on BOTH click and touchend (capture) so a tap fires even if some ancestor
  // swallows the synthetic click on mobile. handle() is idempotent via data-d2busy.
  document.addEventListener('click', handle, false);
  document.addEventListener('touchend', function(e){
    var t = e.target;
    if (t && ((t.closest && t.closest('.d2-upsell__add')) || (t.parentElement && t.parentElement.closest && t.parentElement.closest('.d2-upsell__add')))) {
      handle(e);
    }
  }, false);
})();

/* d2-vidkeep — shop-wide video keep-alive (2026-07-29).
   Own playback for EVERY <video>: anything that pauses one (scroll-out, tab switch,
   iOS low-power, stalled buffer) previously left it frozen for good, because each
   video was started exactly once by its own lazy script. Separate IIFE by design. */
(function () {
  var POLL = 1000, STALL_LIMIT = 3, seen = 'd2vk';
  function inView(v) {
    var r = v.getBoundingClientRect();
    if (!r.width && !r.height) return false;
    return r.top < (window.innerHeight || 0) + 200 && r.bottom > -200;
  }
  function hydrate(v) {
    var ds = v.getAttribute('data-src');
    if (ds && !v.getAttribute('src')) { v.setAttribute('src', ds); try { v.load(); } catch (e) {} }
  }
  function kick(v) {
    if (!v.muted) v.muted = true;
    v.defaultMuted = true;
    if (!v.hasAttribute('playsinline')) v.setAttribute('playsinline', '');
    if (!v.loop) v.loop = true;
    hydrate(v);
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function adopt(v) {
    if (v.dataset[seen]) return;
    v.dataset[seen] = '1'; v.dataset.d2vkT = '-1'; v.dataset.d2vkS = '0';
    ['pause','stalled','waiting','suspend','error','ended'].forEach(function (ev) {
      v.addEventListener(ev, function () {
        if (inView(v)) setTimeout(function () { kick(v); }, 120);
      }, false);
    });
    if (inView(v)) kick(v);
  }
  function scan() {
    var vs = document.getElementsByTagName('video'), i, v, t, s;
    for (i = 0; i < vs.length; i++) {
      v = vs[i]; adopt(v);
      if (!inView(v)) { v.dataset.d2vkS = '0'; continue; }
      if (v.paused || v.ended) { kick(v); continue; }
      t = String(v.currentTime);
      if (t === v.dataset.d2vkT) {
        s = (parseInt(v.dataset.d2vkS, 10) || 0) + 1;
        v.dataset.d2vkS = String(s);
        if (s >= STALL_LIMIT) { v.dataset.d2vkS = '0'; try { v.load(); } catch (e) {} kick(v); }
      } else { v.dataset.d2vkT = t; v.dataset.d2vkS = '0'; }
    }
  }
  function start() {
    scan();
    setInterval(scan, POLL);
    ['scroll','touchend','orientationchange','resize'].forEach(function (ev) {
      window.addEventListener(ev, scan, { passive: true });
    });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) scan(); }, false);
    window.addEventListener('pageshow', scan, false);
    if (window.MutationObserver) {
      new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* d2-heroplace — shop-wide hero overlay collision fix (2026-07-29).
   The FLASH-SALE ribbon sits at a hardcoded `top` while the headline block above it
   is free-flowing text. A two-line headline (long product name, narrow viewport,
   bigger system font) grew down THROUGH the ribbon. Instead of guessing pixels per
   breakpoint, measure the headline and park the ribbon under it, always.
   Separate IIFE by design. */
(function () {
  var GAP = 14;

  function place() {
    var heads = document.querySelectorAll('.d2-hero-head');
    for (var i = 0; i < heads.length; i++) {
      var h = heads[i];
      var c = h.parentElement;
      if (!c) continue;
      var r = c.querySelector('.d2-sale-ribbon');
      if (!r) continue;
      var want = Math.round(h.offsetTop + h.offsetHeight + GAP);
      /* never pull the ribbon ABOVE its stylesheet position — only push it down */
      var base = parseInt(r.getAttribute('data-d2base') || '', 10);
      if (isNaN(base)) {
        base = parseInt(window.getComputedStyle(r).top, 10) || 0;
        r.setAttribute('data-d2base', String(base));
      }
      var top = Math.max(base, want);
      if (r.style.top !== top + 'px') r.style.top = top + 'px';
    }
  }

  function boot() {
    place();
    /* the ribbon + headline are injected by the section script, so keep re-checking
       while the page settles, then on every event that can reflow the text */
    var n = 0, iv = setInterval(function () { place(); if (++n > 40) clearInterval(iv); }, 250);
    ['resize', 'orientationchange', 'load', 'pageshow'].forEach(function (ev) {
      window.addEventListener(ev, place, false);
    });
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(place);
    }
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(place);
      document.querySelectorAll('.d2-hero-head').forEach(function (h) { ro.observe(h); });
      var mo = new MutationObserver(function () {
        document.querySelectorAll('.d2-hero-head').forEach(function (h) {
          if (!h.dataset.d2ro) { h.dataset.d2ro = '1'; ro.observe(h); }
        });
        place();
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ── d2-drawerboot ── the cart drawer must EXIST on a cold visit (2026-07-29/30).
   Bug: the theme renders <cart-drawer> only when the cart is NOT empty. Every first-time
   visitor has an empty cart, so ADD TO CART added the item and then had nothing to open —
   no feedback at all, and the shopper left. On cold paid traffic that is every single user.
   Fix: if the element is missing, fetch the cart-drawer section, inject it, wait for the
   custom element to upgrade, then open it. Shop-wide, so every product gets it.
   Separate IIFE by design. */
(function () {
  var booting = null;

  function drawer() { return document.querySelector('cart-drawer'); }

  function ensureDrawer() {
    var el = drawer();
    if (el && typeof el.open === 'function') return Promise.resolve(el);
    if (booting) return booting;
    booting = fetch('/?sections=cart-drawer&_d2=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j['cart-drawer'];
        if (!html) return null;
        var host = document.createElement('div');
        host.innerHTML = html;
        var node = host.querySelector('cart-drawer');
        if (!node) {                       /* section wrapper without the custom element */
          var inner = host.querySelector('#CartDrawer');
          if (!inner) return null;
          node = document.createElement('cart-drawer');
          node.className = 'drawer';
          node.appendChild(inner);
        }
        if (!drawer()) document.body.appendChild(node);
        return (window.customElements && customElements.whenDefined
                ? customElements.whenDefined('cart-drawer') : Promise.resolve())
          .then(function () { return drawer(); });
      })
      .catch(function () { return null; })
      .then(function (el) { booting = null; return el; });
    return booting;
  }

  function openDrawer() {
    return ensureDrawer().then(function (el) {
      if (!el) { window.location.href = '/cart'; return; }   /* last resort: never a dead click */
      if (typeof el.open === 'function') { el.open(); return; }
      el.classList.add('active');
      document.body.classList.add('overflow-hidden');
    });
  }

  window.d2OpenCartDrawer = openDrawer;

  /* refresh the drawer body after any /cart/ write, then show it */
  function refreshAndOpen() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble&_d2=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        return ensureDrawer().then(function (el) {
          if (el && typeof el.renderContents === 'function') {
            try { el.renderContents({ sections: j }); } catch (e) {}
          } else if (el && j['cart-drawer']) {
            var host = document.createElement('div');
            host.innerHTML = j['cart-drawer'];
            var fresh = host.querySelector('#CartDrawer');
            var cur = el.querySelector('#CartDrawer');
            if (fresh && cur) cur.replaceWith(fresh);
          }
          return openDrawer();
        });
      })
      .catch(openDrawer);
  }
  window.d2RefreshCartDrawer = refreshAndOpen;

  /* Catch every add-to-cart on the page, whatever markup it uses, and make sure the
     shopper always SEES something happen. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute) return;
    var act = f.getAttribute('action') || '';
    if (act.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    /* И тема, и этот обработчик слали свой POST — один клик уходил ДВУМЯ запросами, и в
       корзину ложилось вдвое больше, чем выбрал покупатель (замерено 2026-07-30: 2 запроса
       на один клик). Останавливаем цепочку: добавляет только этот код, он же открывает
       шторку и умеет откатиться в /cart, если что-то пошло не так. */
    e.stopImmediatePropagation();
    var fd = new FormData(f);
    fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) {
          /* Дропшип: «нет в наличии» не бывает. Отказ здесь = рынок покупателя не включён
             в магазине. Слово покупателю не показываем никогда — тихий повтор, потом корзина. */
          if (!f.dataset.d2retried) {
            f.dataset.d2retried = '1';
            return new Promise(function (r) { setTimeout(r, 500); })
              .then(function () {
                return fetch('/cart/add.js', { method: 'POST', body: new FormData(f) });
              })
              .then(function (r2) { return r2.ok ? refreshAndOpen() : (window.location.href = '/cart'); })
              .catch(function () { window.location.href = '/cart'; });
          }
          window.location.href = '/cart';
          return;
        }
        return refreshAndOpen();
      })
      .catch(function () { window.location.href = '/cart'; });
  }, true);

  /* warm the drawer up on first interaction so the very first click is instant */
  ['touchstart', 'mousedown'].forEach(function (ev) {
    window.addEventListener(ev, function warm() {
      window.removeEventListener(ev, warm, true);
      if (!drawer()) ensureDrawer();
    }, true);
  });
})();

/* d2-cartguard — the drawer must NEVER show a blank panel. (Артур, 2026-07-30, live traffic)
 *
 * A blank drawer is worse than no drawer: the customer taps BUY, a white sheet slides up, and
 * they leave. It has two independent causes, and this watchdog kills both:
 *
 *   1. The `is-empty` class on <cart-drawer> is written by Liquid at page render. When the last
 *      line is removed client-side, the class is not re-applied, so the theme's "your cart is
 *      empty" block stays display:none — panel renders blank.
 *   2. A section re-render that comes back short (throttled storefront, network hiccup) wipes the
 *      body while the cart still has items — panel renders blank with a full cart behind it.
 *
 * Cheap by design: the check is pure DOM and runs only while the drawer is visible. It touches the
 * network exactly once, and only in the broken case, to tell cause 1 from cause 2.
 */
(function () {
  if (window.__d2CartGuard) return;
  window.__d2CartGuard = true;

  var busy = false, probing = false, lastFix = 0, redraws = 0;
  var MAX_REDRAWS = 3;   // a blank panel that survives 3 re-renders is not a render bug

  function drawer() { return document.querySelector('cart-drawer'); }

  function visible(el) {
    if (!el) return false;
    var cs = getComputedStyle(el), r = el.getBoundingClientRect();
    return cs.visibility === 'visible' && cs.display !== 'none' && r.width > 100 && r.height > 200;
  }

  function rows() {
    return document.querySelectorAll('#CartDrawer .cart-item, #CartDrawer tr.cart-item').length;
  }

  function emptyShown() {
    var e = document.querySelector('#CartDrawer .drawer__inner-empty, cart-drawer .drawer__inner-empty,'
                               + ' #CartDrawer .d2-empty-fallback, cart-drawer .d2-empty-fallback');
    return !!e && getComputedStyle(e).display !== 'none' && e.getBoundingClientRect().height > 20;
  }

  /* Force a coherent empty state, building the markup if the theme shipped none. */
  function showEmpty() {
    var d = drawer(); if (!d) return;
    d.classList.add('is-empty');
    var items = document.querySelector('cart-drawer-items');
    if (items) items.classList.add('is-empty');
    var e = document.querySelector('#CartDrawer .drawer__inner-empty');
    if (e) {
      e.style.setProperty('display', 'flex', 'important');
      e.style.setProperty('flex-direction', 'column', 'important');
      e.style.setProperty('justify-content', 'center', 'important');
      return;
    }
    if (document.querySelector('.d2-empty-fallback')) return;
    var w = document.createElement('div');
    w.className = 'drawer__inner-empty d2-empty-fallback';
    w.setAttribute('style', 'display:flex;flex-direction:column;justify-content:center;' +
      'align-items:center;padding:56px 24px;text-align:center;min-height:40vh');
    w.innerHTML =
      '<h2 class="cart__empty-text" style="margin:0 0 18px;font-size:20px">Twój koszyk jest pusty</h2>' +
      '<a href="/collections/all" style="display:inline-block;padding:14px 28px;background:#1a1a1a;' +
      'color:#fff;border-radius:8px;text-decoration:none;font-weight:600">Wróć do sklepu</a>';
    (document.querySelector('#CartDrawer .drawer__inner') || drawer()).appendChild(w);
  }

  function hideEmpty() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-empty');
    var items = document.querySelector('cart-drawer-items');
    if (items) items.classList.remove('is-empty');
    var fb = document.querySelector('.d2-empty-fallback');
    if (fb) fb.remove();
    var e = document.querySelector('#CartDrawer .drawer__inner-empty');
    if (e) e.style.removeProperty('display');
  }

  /* Cause 2: the cart has items but the panel is blank — pull the section again. */
  function rerender() {
    var d = drawer(); if (!d || busy) return;
    if (redraws >= MAX_REDRAWS) { showEmpty(); return; }  // never loop: honest empty beats blank
    redraws++;
    busy = true;
    fetch('/?sections=cart-drawer&_d2=' + Date.now(), { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        if (t.trim().charAt(0) === '<') return;            // throttled — never inject a bot page
        var j = JSON.parse(t), html = j['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#CartDrawer-CartItems') || doc.querySelector('.drawer__inner');
        var cur = document.querySelector('#CartDrawer-CartItems') || document.querySelector('#CartDrawer .drawer__inner');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  /* Артур, 2026-07-30, скрин с айфона: шторка застряла на полпути анимации — белый лист,
     заголовок «Cart» у нижнего края. Если шторка «открыта», но её содержимое лежит ниже
     середины экрана — дожимаем в конечное положение силой. */
  function unstick(d) {
    var inner = document.querySelector('#CartDrawer .drawer__inner');
    var probe = inner || d;
    var top = probe.getBoundingClientRect().top;
    if (top > window.innerHeight * 0.4) {
      [d, document.getElementById('CartDrawer'), inner].forEach(function (el) {
        if (!el) return;
        el.style.setProperty('transform', 'none', 'important');
        el.style.setProperty('transition', 'none', 'important');
        el.style.setProperty('top', '0', 'important');
      });
      if (inner) inner.scrollTop = 0;
    }
  }

  function check() {
    var d = drawer();
    if (!visible(d)) return;
    unstick(d);
    if (rows() > 0) { hideEmpty(); redraws = 0; return; }   // healthy, items on screen
    if (emptyShown()) return;                          // healthy, honest empty state
    var now = Date.now();
    if (now - lastFix < 2500 || probing) return;
    lastFix = now; probing = true;
    /* Blank panel. One network call decides which cause it is. */
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        if (t.trim().charAt(0) === '<') { showEmpty(); return; }   // throttled: honest empty beats blank
        if (JSON.parse(t).item_count === 0) showEmpty(); else rerender();
      })
      .catch(function () { showEmpty(); })
      .then(function () { probing = false; });
  }

  document.addEventListener('DOMContentLoaded', check);
  setInterval(check, 1000);
  ['click', 'touchend'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(check, 700); setTimeout(check, 1800); }, true);
  });
  try {
    var mt = 0;
    new MutationObserver(function () {          // debounced: the drawer re-renders in bursts
      clearTimeout(mt); mt = setTimeout(check, 300);
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();

/* ── d2-nosoldout ── «нет в наличии» не существует. (Артур, 2026-07-30)
 *
 * Дропшип: склад бесконечный, товар есть всегда. Любая надпись «sold out» / «out of stock» /
 * «unavailable» и любая серая кнопка — это чистый убыток, нулевая польза и ноль правды.
 *
 * Уровни защиты в теме уже стоят (склад = CONTINUE + учёт выключен, тексты в переводах
 * заменены на всех 37 языках). Этот блок — последний рубеж, на клиенте: он ловит всё, что
 * тема или приложение нарисует ДИНАМИЧЕСКИ — при смене варианта, после перерисовки секции,
 * из стороннего скрипта.
 *
 * Честная граница: если продажу блокирует РЫНОК (страна не включена в магазине), товар
 * физически не добавится — это настройка магазина, а не текст. Тогда покупатель всё равно
 * не увидит слова «sold out»: будет тихий повтор, потом переход в корзину.
 */
(function () {
  if (window.__d2NoSoldOut) return;
  window.__d2NoSoldOut = true;

  var WORDS = /sold\s*out|out of stock|unavailable|нет в наличии|распродано/i;
  var BUY = '[name="add"], .product-form__submit, .vt-buy-btn, .vt-cta-bar__btn, .d2-rf__btn,' +
            ' button[type="submit"][form*="product"], .shopify-payment-button__button';

  function unlock() {
    var n = document.querySelectorAll(BUY);
    for (var i = 0; i < n.length; i++) {
      var b = n[i];
      if (b.disabled) b.disabled = false;
      if (b.hasAttribute('disabled')) b.removeAttribute('disabled');
      if (b.getAttribute('aria-disabled') === 'true') b.setAttribute('aria-disabled', 'false');
      b.classList.remove('disabled', 'sold-out', 'is-sold-out');
      /* подпись кнопки никогда не говорит «нет» */
      var t = b.querySelector('span:not([class*="icon"])') || b;
      if (t && t.childElementCount === 0 && WORDS.test(t.textContent || '')) {
        t.textContent = 'DODAJ DO KOSZYKA';
      }
    }
    /* бейджи «sold out» на карточках и на товаре */
    var bad = document.querySelectorAll('.badge--sold-out, [class*="sold-out"], [class*="sold_out"]');
    for (var j = 0; j < bad.length; j++) {
      if (bad[j].closest && bad[j].closest('script, style')) continue;
      bad[j].style.setProperty('display', 'none', 'important');
    }
  }

  /* Фильтр в каталоге предлагал «Availability: Out of stock (0)» — бессмысленный для
     дропшипа пункт, который вслух произносит запрещённое слово. Прячем всю группу. */
  function killFacets() {
    var lab = document.querySelectorAll('.facet-checkbox__text-label, .facets__label, legend, summary');
    for (var i = 0; i < lab.length; i++) {
      var txt = (lab[i].textContent || '').trim();
      if (WORDS.test(txt) || /^availability$/i.test(txt)) {
        var box = lab[i].closest('.facets__display-wrapper, .facets__wrapper, details, .facet-checkbox, li');
        (box || lab[i]).style.setProperty('display', 'none', 'important');
      }
    }
  }

  unlock(); killFacets();
  document.addEventListener('DOMContentLoaded', function () { unlock(); killFacets(); });
  setInterval(function () { unlock(); killFacets(); }, 1200);
  try {
    var t = 0;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { unlock(); killFacets(); }, 120); })
      .observe(document.documentElement, { childList: true, subtree: true, attributes: true,
                                           attributeFilter: ['disabled', 'class'] });
  } catch (e) {}

  /* Ни одно всплывающее сообщение не имеет права произнести это слово. */
  var origAlert = window.alert;
  window.alert = function (m) {
    if (typeof m === 'string' && WORDS.test(m)) return;      // молча гасим
    return origAlert.apply(window, arguments);
  };
})();

/* d2-policy-titles 2026-10-12: tytuły stron prawnych = nazwy linków w stopce (Regulamin, Zwroty i reklamacje, Dostawa) */
(function(){try{var m=location.pathname.match(/\/policies\/([a-z-]+)/);if(!m)return;var N={"terms-of-service":"Regulamin","refund-policy":"Zwroty i reklamacje","shipping-policy":"Dostawa","privacy-policy":"Polityka prywatności","legal-notice":"Nota prawna","contact-information":"Dane kontaktowe"};var t=N[m[1]];if(!t)return;function go(){var h=document.querySelector(".shopify-policy__title h1, .shopify-policy__title");if(h){(h.querySelector("h1")||h).textContent=t;}document.title=t+" – Nynli";}if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",go);}else{go();}}catch(e){}})();
